import { Lexer } from '../types'
import { eatChar } from './eat-char'
import { hasData } from './has-data'

export function eatStringLiteral(
  lexer: Lexer,
  type: '"' | "'",
  options: { count?: number, countNewLines?: boolean } = {}
): { value: string; error: boolean } {
  const { count = Infinity, countNewLines = false  } = options

  let value = eatChar(lexer)
  let error = false
  let i = 0;

  accumulator: while (hasData(lexer) && i < count) {
    const char = lexer.source[lexer.index]

    switch (char) {
      /* Eat escape sequence */
      case '\\': {
        value += eatChar(lexer, 2)

        break
      }
      case type:
        break accumulator
      case '\n': {
        if (countNewLines) {
          lexer.col = 0
          lexer.line++
        }

        value += eatChar(lexer)

        break
      }
      default:
        value += eatChar(lexer)
    }

    i++
  }

  if (lexer.source[lexer.index] !== type) error = true
  else value += eatChar(lexer)

  return { value, error }
}
